<div class="layout-col full">
  <app-work-schedule-edit
    class="flex"
    [schedule]="schedule$ | async"
    (scheduleChanged)="onScheduleChange($event)"
  ></app-work-schedule-edit>
</div>
